import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { EApiMiddlewareMethods } from "../../network/networkHandler.types";
import { cWingsServiceBaseURL } from "../../config/Api.config";
import { NotificationCenterState, Messages, FetchNotificatioRequest, Count } from "./notificationCenterSlice.types";

import AppConstants from "../../constants";
import customNetworHandler from "../../network/customNetworHandler";


// Async thunk for fetching tip records
export const fetchMessageFromCenter = createAsyncThunk<
   Messages,
   FetchNotificatioRequest,
  { rejectValue: { error: string; message: string } }
>(
  "notification/FetchMessageFromCenter",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const request = {
        url: "/fulfilment/v1/message-center",
        method: EApiMiddlewareMethods.POST,
        data: filters,
      };
      const { data } = await customNetworHandler(request, cWingsServiceBaseURL);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchNotificationCount = createAsyncThunk<
   Count,
   FetchNotificatioRequest,
  { rejectValue: { error: string; message: string } }
>(
  "notification/FetchNotificationCount",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const request = {
        url: "fulfilment/v1/message-center/count",
        method: EApiMiddlewareMethods.POST,
        data: filters,
      };
      const { data } = await customNetworHandler(request, cWingsServiceBaseURL);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const ackMessage = createAsyncThunk<
   Count,
   string | undefined,
  { rejectValue: { error: string; message: string } }
>(
  "notification/ackMessage",
  async (id, { rejectWithValue }) => {
    try {
      const request = {
        url: id
          ? `/fulfilment/v1/message-center/${id}/ack` // Use `id` if provided
          : `/fulfilment/v1/message-center/ack`, // Fallback URL if `id` is not provided
        method: EApiMiddlewareMethods.GET,
      };
      const { data } = await customNetworHandler(request, cWingsServiceBaseURL);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);


// Initial state with proper types
const initialState: NotificationCenterState = {
  loading: false,
  errorCode: "",
  error: "",
  messages: { elements: [], pageNumber: 0, totalElements: 0, totalPages: 0 },
  notificationCount: 0,
};

// Slice definition
const NotificationCenterSlice = createSlice({
  name: "NotificationCenter",
  initialState,
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchMessageFromCenter.pending, (state) => {
        state.loading = true;
        state.errorCode = "";
        state.error = "";
      })
      .addCase(fetchMessageFromCenter.fulfilled, (state, action) => {
        const {
          payload,
      } = action;
        state.loading = false;
        if (payload) {
        state.messages = {
            ...payload,
            elements: payload?.elements,
            pageNumber: payload?.pageNumber || 0,
            totalElements: payload?.totalElements || 0,
            totalPages: payload?.totalPages || 0,
          };
        }
     
      })
      .addCase(fetchMessageFromCenter.rejected, (state, action) => {
        state.loading = false;
        const errorPayload: any = action?.payload;
        state.errorCode = errorPayload
          ? errorPayload?.error
          : AppConstants.RESPONSE_CONSTANTS.ERROR_CODES.DEFAULT_API_FAILED;
        state.error =
          errorPayload && errorPayload?.message
            ? errorPayload?.message || ""
            : AppConstants.RESPONSE_CONSTANTS.DEFAULT_API_FAILED_ERROR_MSG;
      })
      .addCase(fetchNotificationCount.pending, (state) => {
        state.loading = true;
        state.errorCode = "";
        state.error = "";
      })
      .addCase(fetchNotificationCount.fulfilled, (state, action) => {
        const {
          payload,
      } = action;
        state.loading = false;
        if (payload.results !== undefined) {
        state.notificationCount = payload.results
        }
      })
      .addCase(fetchNotificationCount.rejected, (state, action) => {
        state.loading = false;
        const errorPayload: any = action?.payload;
        state.errorCode = errorPayload
          ? errorPayload?.error
          : AppConstants.RESPONSE_CONSTANTS.ERROR_CODES.DEFAULT_API_FAILED;
        state.error =
          errorPayload && errorPayload?.message
            ? errorPayload?.message || ""
            : AppConstants.RESPONSE_CONSTANTS.DEFAULT_API_FAILED_ERROR_MSG;
      })
      .addCase(ackMessage.pending, (state) => {
        state.loading = true;
        state.errorCode = "";
        state.error = "";
      })
      .addCase(ackMessage.fulfilled, (state, action) => {
        const {
          payload,
      } = action;
        state.loading = false;
        if (payload.results !== undefined) {
        state.notificationCount = payload.results
        }
      })
      .addCase(ackMessage.rejected, (state, action) => {
        state.loading = false;
        const errorPayload: any = action?.payload;
        state.errorCode = errorPayload
          ? errorPayload?.error
          : AppConstants.RESPONSE_CONSTANTS.ERROR_CODES.DEFAULT_API_FAILED;
        state.error =
          errorPayload && errorPayload?.message
            ? errorPayload?.message || ""
            : AppConstants.RESPONSE_CONSTANTS.DEFAULT_API_FAILED_ERROR_MSG;
      })
  },
});

export default NotificationCenterSlice.reducer;
